(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linkspot-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ls-grid-carousel')) {
    /**
     * Carousel layout of the LinkSpot Grid. The track already scrolls natively
     * (swipe, trackpad, focus), so this only adds what CSS can't do: the arrows,
     * the slide labels and following the selected block in the theme editor.
     */
    class LsGridCarousel extends HTMLElement {
      /** @type {HTMLElement|null} */
      #track = null;
      /** @type {HTMLButtonElement|null} */
      #prev = null;
      /** @type {HTMLButtonElement|null} */
      #next = null;
      /** @type {AbortController|null} */
      #abort = null;
      /** @type {ResizeObserver|null} */
      #resizeObserver = null;

      connectedCallback() {
        this.#track = this.querySelector('.ls-grid-section__inner--carousel');
        if (!this.#track) return;

        this.#prev = this.querySelector('.ls-grid-carousel__arrow--prev');
        this.#next = this.querySelector('.ls-grid-carousel__arrow--next');
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.#labelSlides();
        this.#prev?.addEventListener('click', () => this.#page(-1), { signal });
        this.#next?.addEventListener('click', () => this.#page(1), { signal });
        this.#track.addEventListener('scroll', () => this.#update(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => this.#reveal(event.target), { signal });

        // Fires once on observe, which sets the initial arrow state.
        this.#resizeObserver = new ResizeObserver(() => this.#update());
        this.#resizeObserver.observe(this.#track);
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#resizeObserver?.disconnect();
      }

      #labelSlides() {
        const slides = this.#track.querySelectorAll(':scope > .ls-grid-item');

        for (const [index, slide] of slides.entries()) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${index + 1} of ${slides.length}`);
        }
      }

      /**
       * Scrolls by one page: the visible width plus one gap, which moves
       * exactly the number of visible columns.
       * @param {1|-1} direction
       */
      #page(direction) {
        const style = getComputedStyle(this.#track);
        const visibleWidth =
          this.#track.clientWidth - parseFloat(style.paddingInlineStart) - parseFloat(style.paddingInlineEnd);
        const step = visibleWidth + (parseFloat(style.columnGap) || 0);
        const inline = style.direction === 'rtl' ? -1 : 1;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.#track.scrollBy({ left: direction * inline * step, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      #update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.#track;
        const maxScroll = scrollWidth - clientWidth;
        // RTL tracks scroll into negative values, so compare distances from the start.
        const position = Math.abs(scrollLeft);

        this.toggleAttribute('data-overflow', maxScroll > 1);
        if (this.#prev) this.#prev.disabled = position <= 1;
        if (this.#next) this.#next.disabled = position >= maxScroll - 1;
      }

      /**
       * Theme editor: keeps the selected item, or a block inside it, in view.
       * @param {EventTarget|null} target
       */
      #reveal(target) {
        if (!(target instanceof Element)) return;

        const slide = target.closest('.ls-grid-item');
        if (!slide || slide.parentElement !== this.#track) return;

        slide.scrollIntoView({ block: 'nearest', inline: 'start' });
      }
    }

    customElements.define('ls-grid-carousel', LsGridCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
